/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/no-this-alias */
/* eslint-disable @typescript-eslint/no-unused-vars */
import './sentry';
import $ from 'jquery';

import { Loader } from './spd/loader';
import { SPDKeyboard } from './spd/spdKeyboard';
import * as Configuration from './spd/testConfiguration';
import { Speaker } from './spd/speaker';
import { TextSelector } from './spd/textSelector';
import { FooterTools } from './spd/footerTools';
import {
  setRunTestWithCore,
  DEBUG_MODE,
  getBuildVersion,
  ulrDefaultDbTexts,
  setModeAuthorized,
  switchOffDebugMode,
  brandSPD,
  cooperatorSPD,
  setRunAsDemo,
  isDemoMode,
  getFinishPageUrl,
} from './spdConfig';
import './css/fonts.css';
import './css/defaultStyle.css';
import {
  AuthError,
  AuthStatus,
  checkAuthState,
  signIn,
  signOut,
  signOutOnlyPublicUser,
} from './spd/auth';
import { Announcement } from './spd/announcement';
import { SupervisorMonitor } from './spd/supervisorMonitor';
import { FullScreen } from './spd/fullScreen';
import StethoMe from './spd/stetho/index';
import { SPDPageGateway } from './spd/spdPageGateway';
import { ActiveStep } from './spd/activeStep';
import { ModeSurvey } from './spd/survey';
import { VersionChecker } from './spd/versionChecker';
import ECGWecardio from './spd/wecardio';
import { Spin } from './spd/spin';
import DistanceTracker from './spd/tools/distanceTracker';

//index.html -> auth -> loadMainPage -> setLanguage -> loadPinPage -> authorizeSurveyByPin -> setGender -> startSurvey
//           -> authPublic -> loadPinForPublicPage  -> authorizeSurveyForPublicUser        -> setGender -> startSurvey
//                                                                                         -> selectGenderPage -> startSurvey
export class SPD extends SPDPageGateway {
  public stethoMe: typeof StethoMe = StethoMe;
  public ecgWebcardio: typeof ECGWecardio = ECGWecardio;
  public distanceTracker: typeof DistanceTracker = DistanceTracker;

  private versionChecker = new VersionChecker();

  protected speakerON = true;
  public longTouchActive: EventTarget | null = null;

  protected async authDemo() {
    const that = this;
    setRunAsDemo(true);

    supervisorMonitor.setPublicMode();
    setRunTestWithCore(true);
    setModeAuthorized(true);
    testConfiguration.public = true;

    await defaultDbTextSelector.loadDbTexts(ulrDefaultDbTexts);
    const callback = () => that.loadMainPage(false);
    checkAuthState(false, true, callback, async () => {
      await that.surveyManager.publicSignIn(callback);
    });
  }

  protected async authPublicWithExternalId(externalId: string) {
    const that = this;
    await this.authPublicGeneric(async () => {
      if (!ActiveStep.isItActiveStep('loadPinForPublicPage')) {
        //zabezpieczenie przed ponownym ładowaniem ekranu PIN w trakcie logowania
        await that.loadPinForPublicPage(externalId);
      }
    });
  }

  protected async authPublicWithToken(token: string) {
    const that = this;
    await this.authPublicGeneric(async () => {
      await that.surveyManager.authorizeSurveyByToken(
        token,
        () => {
          that.selectGenderPage();
        },
        async () => {
          const jwtPayload = this.decodeJWT(token);
          const externalId = jwtPayload?.examId as string;
          if (!externalId) {
            Announcement.announcementAuthError(
              new AuthError('auth/invalid-token', ''),
            );
            return;
          }
          window.location.href = `${
            window.location.origin + window.location.pathname
          }?external=${externalId}`;
          await that.loadPinForPublicPage(externalId);
        },
      );
    });
  }

  protected async auth(
    authorize: boolean,
    specialist: boolean,
    callback: () => void,
  ) {
    if (!(await this.versionChecker.isServiceSPDAvailable())) {
      return;
    }

    await defaultDbTextSelector.loadDbTexts(ulrDefaultDbTexts);
    supervisorMonitor.setStandardMode();

    setModeAuthorized(authorize);

    if (authorize) {
      const that = this;
      checkAuthState(
        specialist,
        false,
        () => callback(),
        () => that.loginUserPage(callback),
      );
    } else {
      await signOut();
      callback && callback();
    }
  }

  //pozwala uruchomić platformę z konkretnym zadaniem - do szybkiego testowania
  protected async loadTestTaskPage(
    startTest: number,
    startTask: number,
    id: string,
    core: boolean,
  ) {
    await this.surveyManager.loadTestTaskPage(startTest, startTask, id, core);
  }

  protected async runPsychologistMode(
    id: string,
    mode: ModeSurvey,
    core: boolean,
  ) {
    await this.surveyManager.runPsychologistMode(id, mode, core);
  }

  protected async loginUser(callback: () => void) {
    const email = $('#email').val() as string;
    const psw = $('#psw').val() as string;
    await this.signIn(email, psw, callback);
  }

  protected async loginUserPage(callback: () => void) {
    const that = this;
    Loader.loadContentWithVersion(
      '#main',
      'template/login_page-template.mst',
      null,
      () => {
        FooterTools.showPowered(true);
        FooterTools.addTools({ logout: false });
        SPDKeyboard.showFullKeyboard(Configuration.Lange.PL, '', false);
        $('#psw').on('keypress', (event: JQuery.KeyPressEvent) =>
          that.enter(event, () => that.loginUser(callback)),
        );
      },
    );
  }

  protected async signIn(email: string, psw: string, callback: () => void) {
    try {
      await FullScreen.openFullscreen();

      const signedInStatus = await signIn(email, psw);

      switch (signedInStatus) {
        case AuthStatus.CorrectAuth:
          callback && callback();
          break;
        case AuthStatus.WrongRole:
          Announcement.announcementAbout('wrong_user_role'); /// muszę to obsłużyć alertem gdyż strona się przeładowuje w wyniku wylogania po zalogowaniu
          break;
      }
    } catch (error) {
      Announcement.announcementAuthError(error as AuthError);
    }
  }

  public async loadMainPage(core: boolean) {
    setRunTestWithCore(core);
    const that = this;
    that.versionChecker.activateStatusVersionCheck();
    that.clearAllTimers();
    //await defaultDbTextSelector.loadDbTexts(ulrDefaultDbTexts);
    const data = {
      lange_en: defaultDbTextSelector.getText('lange', Configuration.Lange.EN),
      lange_pl: defaultDbTextSelector.getText('lange', Configuration.Lange.PL),
      lange_ua: defaultDbTextSelector.getText('lange', Configuration.Lange.UA),
      lange_ru: defaultDbTextSelector.getText('lange', Configuration.Lange.RU),
      lange_ge: defaultDbTextSelector.getText('lange', Configuration.Lange.GE),
      lange_tr: defaultDbTextSelector.getText('lange', Configuration.Lange.TR),
      lange_tj: defaultDbTextSelector.getText('lange', Configuration.Lange.TJ),
      lange_by: defaultDbTextSelector.getText('lange', Configuration.Lange.BY),
      lange_uz: defaultDbTextSelector.getText('lange', Configuration.Lange.UZ),
      lange_de: defaultDbTextSelector.getText('lange', Configuration.Lange.DE),
      lange_ar: defaultDbTextSelector.getText('lange', Configuration.Lange.AR),
      lange_sq: defaultDbTextSelector.getText('lange', Configuration.Lange.SQ),
      lange_sk: defaultDbTextSelector.getText('lange', Configuration.Lange.SK),
      lange_lt: defaultDbTextSelector.getText('lange', Configuration.Lange.LT),
      lange_es: defaultDbTextSelector.getText('lange', Configuration.Lange.ES),
      lange_fr: defaultDbTextSelector.getText('lange', Configuration.Lange.FR),
      lange_ph: defaultDbTextSelector.getText('lange', Configuration.Lange.PH),
      lange_vn: defaultDbTextSelector.getText('lange', Configuration.Lange.VN),
      lange_ro: defaultDbTextSelector.getText('lange', Configuration.Lange.RO),
      lange_hi: defaultDbTextSelector.getText('lange', Configuration.Lange.HI),
      cooperation: defaultDbTextSelector.getText('cooperation'),
      brand: brandSPD,
      cooperator: cooperatorSPD,
      demo: isDemoMode(),
      version: getBuildVersion(),
    };
    if (isDemoMode()) {
      $('body').addClass('demo');
    } else {
      $('body').addClass('lange-body');
    }
    Loader.loadContentWithVersion(
      '#main',
      'template/lang_page-template.mst',
      data,
    );
    FooterTools.addTools({
      mode: true,
      logout: true,
      powered: true,
      version: true,
      refresh: true,
      demo: true,
    });
  }

  //// wołane z lang_page-template.mst - przekierowujące na loadPinPage
  public async setLanguage(lange: string) {
    const that = this;
    that.versionChecker.deactivateStatusVersionCheck(); ///wyłączam sprawdzanie wersji

    testConfiguration.lange = (lange ||
      testConfiguration.lange) as Configuration.Lange;
    const text = defaultDbTextSelector.getText('chosen_lange');
    speaker.setLange(testConfiguration.lange);
    supervisorMonitor.setLange(testConfiguration.lange);

    await FullScreen.openFullscreen();
    $('body').removeClass('lange-body');
    $('body').removeClass('demo');

    const nextStep = isDemoMode()
      ? async () => await that.authorizeSurveyByPin()
      : async () => await that.loadPinPage();

    if (text) {
      void speaker.speakText(
        text.text_read,
        false,
        testConfiguration.lange,
        nextStep,
      );
    } else {
      await nextStep();
    }
  }

  protected async loadPinPage() {
    const that = this;

    const access = await this.checkDeviceAccess();
    if (!access) {
      return;
    }

    const data = {
      description: defaultDbTextSelector.getText('pin'),
      action: 'authorizeSurveyByPin()',
    };

    Loader.loadContentWithVersion(
      '#main',
      'template/pin_page-template.mst',
      data,
      function () {
        FooterTools.addTools();
        SPDKeyboard.showPINKeyboard();
        void speaker.playSoundOrSpeakText(
          data.description.text_read,
          false,
          data.description.sound,
        );
        ActiveStep.setActiveStepAfter(() => that.loadPinPage(), 'loadPinPage');
      },
    );
  }

  public async authorizeSurveyByPin() {
    Spin.showSpin('loading', '...');

    await this.surveyManager.authorizeSurveyByPin(
      $('#pin').val() as string,
      () => this.selectGenderPage(),
      () => this.loadPinPage(),
    );
  }

  protected async loadPinForPublicPage(externalId: string) {
    console.log('loadPinForPublicPage', externalId);
    const that = this;
    ///await openFullscreen();
    const data = {
      description: defaultDbTextSelector.getText('pin'),
      action: `authorizeSurveyForPublicUser("${externalId}")`,
    };

    Loader.loadContentWithVersion(
      '#main',
      'template/pin_page-template.mst',
      data,
      function () {
        FooterTools.addTools();
        SPDKeyboard.showPINKeyboard();
        void speaker.playSoundOrSpeakText(
          data.description.text_read,
          false,
          data.description.sound,
        );
        ActiveStep.setActiveStepAfter(
          () => that.loadPinForPublicPage(externalId),
          'loadPinForPublicPage',
        );
      },
    );
  }

  public async authorizeSurveyForPublicUser(externalId: string) {
    await FullScreen.openFullscreen();
    Spin.showSpin('loading', '...');

    await this.surveyManager.authorizeSurveyForPublicUser(
      $('#pin').val() as string,
      externalId,
      () => this.selectGenderPage(),
      () => this.loadPinForPublicPage(externalId),
    );
  }

  protected selectGenderPage() {
    const that = this;
    const data = {
      header: defaultDbTextSelector.getText('header'),
      man: defaultDbTextSelector.getText('man'),
      woman: defaultDbTextSelector.getText('woman'),
      version: getBuildVersion(),
    };
    Loader.loadContentWithVersion(
      '#main',
      'template/gender_page-template.mst',
      data,
      function () {
        FooterTools.addTools();
        //data.header && speaker.speakText(data.header.text_read);
        data.header &&
          void speaker.playSoundOrSpeakText(
            data.header.text_read,
            false,
            data.header.sound,
          );

        ActiveStep.setActiveStepAfter(
          () => that.selectGenderPage(),
          'selectGenderPage',
        );
      },
    );
  }

  /// wołane z survey_page-template.mst i w tools-template.mst
  public restartSPD() {
    //window.location.reload(); -- poniżej kod umożliwiający zaczytanie wersji bez cache
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);

    // Dodaje lub zaktualizuj parametr "nocache" z unikalną wartością
    params.set('nocache', `${new Date().getTime()}`);

    url.search = params.toString();
    window.location.href = url.toString();
  }

  public loadFinishPage() {
    const target = new URL(getFinishPageUrl(), window.location.origin);
    const params = target.searchParams;
    params.set('nocache', `${new Date().getTime()}`);
    target.search = params.toString();
    window.location.href = target.toString();
  }

  public async reloadWithDemo(): Promise<void> {
    const demo = isDemoMode();
    const url = new URL(window.location.href);

    if (isDemoMode()) {
      await signOutOnlyPublicUser(); ///wylogowuje na wszelki wypadek użytkownika jeśli to był publiczny
      url.searchParams.delete('demo');
    } else {
      url.searchParams.set('demo', 'true');
    }

    window.location.replace(url.toString());
  }

  /// wołane przy inicjacji aplikacji
  public offDefaultTouch(element: Element | Document, callback: () => void) {
    const that = this;
    let timer: NodeJS.Timeout | null;
    let longTouch = false;

    const cancel = (event: TouchEvent) => {
      that.longTouchActive = null;
      timer && clearTimeout(timer);
    };

    const htmlElement = element as HTMLElement;

    htmlElement.addEventListener(
      'contextmenu',
      (event: MouseEvent | TouchEvent) => {
        // wyłączenie uruchomienia menu kontekstowego przy długim przytrzymaniu palca
        if (longTouch) {
          event.preventDefault();
          longTouch = false;
        }
        return false;
      },
    );
    htmlElement.addEventListener(
      'touchstart',
      (event: TouchEvent) => {
        //event.preventDefault();
        (event.target as HTMLElement).addEventListener(
          'touchend',
          cancel,
          false,
        );
        timer = setTimeout(() => {
          longTouch = true;
          that.longTouchActive = event.target; /// do przekazywania przytrzymania palca między zadaniami
          timer = null;
          callback();
        }, 500);
      },
      { passive: false },
    );

    htmlElement.addEventListener('mousedown', (event: MouseEvent) => {
      if (event.button === 2) {
        longTouch = false;
      }
    });
  }

  private async authPublicGeneric(callback: () => Promise<void>) {
    const that = this;

    if (!(await that.versionChecker.isServiceSPDAvailable())) {
      return;
    }
    switchOffDebugMode(); // w trybie publicznym wyłączam konsole

    supervisorMonitor.setPublicMode();
    setRunTestWithCore(true);
    setModeAuthorized(true);
    testConfiguration.public = true;

    await signOut();
    await defaultDbTextSelector.loadDbTexts(ulrDefaultDbTexts);
    checkAuthState(false, true, null, callback);
  }

  private decodeJWT(token: string): Record<string, unknown> | null {
    try {
      const parts = token.split('.');
      if (parts.length !== 3) {
        throw new Error('Invalid JWT token format');
      }
      const payload = parts[1];
      const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          .join(''),
      );
      return JSON.parse(jsonPayload);
    } catch (error) {
      console.error('Error decoding JWT:', error);
      return null;
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private static getBool = (params: URLSearchParams, key: string, def: any) => {
    if (!params.has(key)) {
      return def;
    }
    const v = params.get(key);
    if (v === 'true') {
      return true;
    }
    if (v === 'false') {
      return false;
    }
    return def;
  };

  // eslint-disable-next-line complexity
  public async parseInitParams(params: URLSearchParams) {
    const demo = SPD.getBool(params, 'demo', false);
    const core = SPD.getBool(params, 'core', true);
    const forceAuth = SPD.getBool(params, 'auth', false);

    const test = (params.get('test') || 0) as number;
    const task = (params.get('task') || 0) as number;
    const mode = params.get('mode') as ModeSurvey;
    const id = params.get('id') || '';
    const external = params.get('external');
    const token = params.get('token');

    if (demo) {
      await this.authDemo();
      return;
    }

    if (external) {
      await this.authPublicWithExternalId(external);
      return;
    }

    if (token) {
      await this.authPublicWithToken(token);
      return;
    }

    const requireAuth = core || forceAuth;

    if (id && mode) {
      await this.auth(requireAuth, true, () =>
        this.runPsychologistMode(id, mode, core),
      );
      return;
    }

    if (test && !core) {
      await this.auth(requireAuth, false, () =>
        this.loadTestTaskPage(test, task, id, core),
      );
      return;
    }

    await this.auth(requireAuth, false, () => spd.loadMainPage(core));
  }
}

declare let supervisorMonitor: SupervisorMonitor;
supervisorMonitor = new SupervisorMonitor();

// eslint-disable-next-line prefer-const
declare let testConfiguration: Configuration.TestConfiguration;

declare let defaultDbTextSelector: TextSelector;

// eslint-disable-next-line prefer-const
declare let speaker: Speaker;

// eslint-disable-next-line prefer-const
declare let spd: SPD;

// eslint-disable-next-line prefer-const
testConfiguration = {
  lange: Configuration.Lange.PL,
  gender: Configuration.Gender.Male,
  public: false,
};

defaultDbTextSelector = new TextSelector();

spd = new SPD();
speaker = new Speaker();
spd.speakerOnOff();
spd.loadCSSMode();

spd.offDefaultTouch(document, () => {
  DEBUG_MODE && console.log('Long touch active');
});

window.addEventListener('spd-signout', () => {
  supervisorMonitor.stopStreaming();
  // Defensywnie wyłączam wszystkie strumienie podpięte do elementów media
  // (np. kamera skanera w aktywnym teście), nawet jeśli flow nie przeładował strony.
  document.querySelectorAll('video, audio').forEach(element => {
    const mediaElement = element as HTMLMediaElement;
    const stream = mediaElement.srcObject as MediaStream | null;
    if (stream) {
      stream.getTracks().forEach(track => track.stop());
      mediaElement.srcObject = null;
    }
  });
});

spd.verifyOnline();

DEBUG_MODE && console.log('Build version:', process.env.BUILD_VERSION);

SPDKeyboard.onInput = () => spd.onInput();
if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
  if (
    /Mobi|Android|iPhone|iPad|iPod|BlackBerry|Windows Phone|Mobile/i.test(
      navigator.userAgent,
    )
  ) {
    DEBUG_MODE &&
      console.log(
        'Urządzenie obsługuje ekran dotykowy i jest to urządzenie mobilne.',
      );
    SPDKeyboard.disableKeyboard = true;
  } else {
    DEBUG_MODE &&
      console.log('Urządzenie stacjonarne obsługuje ekran dotykowy');
  }
} else {
  DEBUG_MODE && console.warn('Urządzenie nie obsługuje ekranu dotykowego.');
  SPDKeyboard.disableKeyboard = true;
}

FullScreen.addFullscreenChangeEvent(() => {
  if (FullScreen.isOpenFullscreen()) {
    $('body').addClass('fullscreen-mode');
  } else {
    $('body').removeClass('fullscreen-mode');
  }
});

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    StethoMe: any;
  }
}

window.StethoMe = StethoMe;
